import script from "./IncidentDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./IncidentDescription.vue?vue&type=script&lang=ts&setup=true"

import "./IncidentDescription.vue?vue&type=style&index=0&id=2a5e0b3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5e0b3d"]])

export default __exports__